<template>
  <div class="slider__container">
    <span class="slider__range left__range">{{startRange}}%</span>
    <vue-slider
      v-model="sliderValue"
      class="slider__component"
      :min="startRange"
      :interval="interval"
      :max="endRange"
      v-on:change="onChange"
    />
    <span class="slider__range right__range">{{endRange}}%</span>
  </div>
</template>
<script>
import 'vue-slider-component/theme/default.css';
import VueSlider from 'vue-slider-component';

export default {
  name: 'Slider',
  props: {
    value: {
      type: Number | String,
      default: 0,
    },
    interval: {
      type: Number,
      default: 1,
      min: 1,
    },
    startRange: {
      type: Number,
      default: 0,
      min: 0,
      max: 100,
    },
    endRange: {
      type: Number,
      default: 100,
      min: 0,
      max: 100,
    },
  },
  computed: {
    sliderValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },

  methods: {
    onChange(value) {
      this.$emit('input', value);
    },
  },
  components: {
    VueSlider,
  },
};
</script>
<style lang="scss">
.slider__container {
  display: flex;
  gap: 8px;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 10px;
}

.slider__component {
  min-width: 240px;
  flex: 1;
}

.vue-slider-dot-handle {
  width: 44px;
  border-radius: 9999px;
  margin-left: -16px;
  box-shadow: 0px 0px 4px 0px #000000;
  background-color: #9AEEC5;
}

.vue-slider-process {
  background: #6BEDAD;
}

.slider__range {
  width: 72px;
  display: block;
  font-size: 18px;
  line-height: 15px;
  color: #BAB3C5;
  font-family: 'Montserrat', sans-serif;
}

.left__range {
  text-align: left;
}
.right__range {
  text-align: right;
}

.vue-slider-dot-tooltip-inner {
  background: transparent;
  &::after {
    display: none;
  }
}

.vue-slider-dot-tooltip-text {
  font-size: 24px;
  line-height: 30px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
}
</style>